import { ArrowRight, Trash2 } from "lucide-react";

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString([], {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

function formatMins(s) {
  const m = Math.round((s || 0) / 60);
  return `${m}m`;
}

export default function SessionHistory({ sessions, onResume, onDelete, compact }) {
  if (!sessions || sessions.length === 0) {
    return (
      <div className="card-soft p-4 text-xs font-mono text-white/40" data-testid="session-history-empty">
        No past sessions yet.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2" data-testid="session-history-list">
      {sessions.slice(0, compact ? 6 : 50).map((s) => (
        <div
          key={s.id}
          className="card-soft p-3 group hover:border-[hsl(var(--green))]/40 transition"
          data-testid="session-history-item"
        >
          <div className="flex items-start justify-between gap-2 mb-1">
            <div className="min-w-0">
              <div className="font-display font-bold text-sm truncate" data-testid="history-item-title">
                {s.title}
              </div>
              <div className="text-[10px] font-mono text-white/40 mt-0.5">
                {formatDate(s.started_at)} · {formatMins(s.elapsed_seconds)} ·{" "}
                <span
                  className={
                    s.status === "completed"
                      ? "text-[hsl(var(--green))]"
                      : s.status === "active"
                      ? "text-[hsl(var(--green))]"
                      : "text-[hsl(var(--pink))]"
                  }
                >
                  {s.status}
                </span>
              </div>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(s.id);
              }}
              className="opacity-0 group-hover:opacity-100 transition text-white/30 hover:text-[hsl(var(--pink))]"
              data-testid="history-delete-button"
              title="Delete"
            >
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
          {s.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1 mb-2">
              {s.tags.slice(0, 3).map((t) => (
                <span
                  key={t}
                  className="text-[10px] font-mono text-white/40"
                >
                  #{t}
                </span>
              ))}
            </div>
          )}
          <button
            onClick={() => onResume(s.id)}
            className="text-[11px] font-mono uppercase tracking-widest text-[hsl(var(--green))]/90 hover:text-[hsl(var(--green))] flex items-center gap-1 group/btn"
            data-testid="history-resume-button"
          >
            Resume <ArrowRight className="w-3 h-3 transition group-hover/btn:translate-x-0.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
